export const advisoryTone = (code: string): 'caution' | 'info' | 'critical' =>
  code === 'bank_account_masking_disabled' || code === 'fdvl_label_not_discreet' ? 'caution'
    : code === 'scheduled_fdvl_change_pending' ? 'caution'
    : 'info';
